export default __webpack_public_path__ + "static/og-image-4b7a07c610494c5456c3a5f3325fa668.jpg";